import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GruppeTier } from '../classes/gruppe-tier';
import { Betriebskontakt } from '../../stammdaten/betriebskontakte/betriebskontakt';
import { GruppeTierService } from '../gruppe-tier.service';
import { MessageService } from '../../../services/message-service/message.service';

@Component({
    selector: 'kiene-gruppe-tier-herkunft-setzen-dialog',
    templateUrl: './gruppe-tier-herkunft-setzen-dialog.component.html',
    styleUrls: ['./gruppe-tier-herkunft-setzen-dialog.component.scss'],
})
export class GruppeTierHerkunftSetzenDialogComponent {
    selectedKontakt: Betriebskontakt | null = null;
    isSaving = false;
    removeHerkunft = false;
    isMobileView = false;
    showSearchBlock = true;

    constructor(
        private readonly dialogRef: MatDialogRef<GruppeTierHerkunftSetzenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { tiere: GruppeTier[] },
        private readonly gruppeTierService: GruppeTierService,
        private readonly messageService: MessageService,
    ) {
        if (typeof window !== 'undefined') {
            this.isMobileView = window.matchMedia('(max-width: 600px)').matches;
        }
    }

    onKontaktSelected(kontakt: Betriebskontakt): void {
        this.selectedKontakt = kontakt;
        this.removeHerkunft = false;
        if (this.isMobileView) {
            this.showSearchBlock = false;
        }
    }

    onKontakteSelected(kontakte: Betriebskontakt[]): void {
        this.selectedKontakt = kontakte?.length > 0 ? kontakte[0] : null;
        this.removeHerkunft = false;
        if (this.isMobileView) {
            this.showSearchBlock = !this.selectedKontakt;
        }
    }

    clearSelection(): void {
        this.selectedKontakt = null;
        this.removeHerkunft = true;
        this.showSearchBlock = true;
    }

    openSearchBlock(): void {
        if (this.isMobileView) {
            this.showSearchBlock = true;
        }
    }

    isSearchVisible(): boolean {
        if (!this.isMobileView) {
            return true;
        }
        return !this.selectedKontakt || this.showSearchBlock;
    }

    isSelectedPreviewVisible(): boolean {
        return this.isMobileView && !!this.selectedKontakt && !this.showSearchBlock;
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

    save(): void {
        if (!this.data?.tiere?.length) {
            this.messageService.errorMessage('Keine Tiere ausgewählt!', null);
            return;
        }

        if (!this.selectedKontakt && !this.removeHerkunft) {
            this.messageService.errorMessage('Bitte wählen Sie einen Herkunftsbetrieb aus oder entfernen Sie ihn.', null);
            return;
        }

        this.isSaving = true;
        this.gruppeTierService
            .updateHerkunftForTiere(this.data.tiere, this.removeHerkunft ? null : this.selectedKontakt)
            .subscribe({
                next: success => {
                    this.isSaving = false;
                    if (!success) {
                        this.dialogRef.close(false);
                        return;
                    }

                    const message = this.removeHerkunft
                        ? 'Herkunftsbetrieb erfolgreich entfernt.'
                        : 'Herkunftsbetrieb für alle ausgewählten Tiere gesetzt.';
                    this.messageService.infoMessage(message);
                    this.dialogRef.close(true);
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Herkunftsbetrieb konnte nicht aktualisiert werden!', err);
                },
            });
    }
}
